import type { ApplicationConfig, Signal } from '@angular/core';
import { inject, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withPreloading } from '@angular/router';
import { preloadActiveLanguage } from '@app/translation.providers';
import { AmlTablePreferenceProviderService } from '@core/services/aml-table-preference-provider.service';
import type { NamedRole } from '@kerberos-compliance/compliance-shared-ts/core/iam/authorization/enums/named-role';
import {
  PermissionBasedPreloadingStrategy,
  PRELOAD_USER_ROLES_TOKEN,
  provideNavigationRegistry,
  TablePreferencesProvider,
  USER_PROFILE_STORAGE_KEY_TOKEN,
  UserProfileStore,
  UserTablePreferencesService,
} from '@kerberos-compliance/compliance-shared-ui';
import { AuthFacade } from '@/auth/facades/auth.facade';
import { StorageServiceKeysMap } from '@/storage/types/storage.types';
import { routes } from './app.routes';
import { getAppModuleProviders } from './provider';
import { provideBaseFacadeContext } from './providers/base-facade-context.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding(), withPreloading(PermissionBasedPreloadingStrategy)),
    provideNavigationRegistry(),
    {
      provide: PRELOAD_USER_ROLES_TOKEN,
      useFactory: (): Signal<NamedRole[]> => inject(AuthFacade).roleDisplayNames,
    },
    provideZonelessChangeDetection(),

    provideBaseFacadeContext(),

    ...getAppModuleProviders(),
    provideAppInitializer(preloadActiveLanguage),
    {
      provide: USER_PROFILE_STORAGE_KEY_TOKEN,
      useValue: StorageServiceKeysMap.UserProfile,
    },
    UserProfileStore,
    UserTablePreferencesService,
    { provide: TablePreferencesProvider, useClass: AmlTablePreferenceProviderService },
  ],
};
